// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3x-sZ","title":"Images45_title__1KjYe","images":"Images45_images__diJbC"};